module.exports = __webpack_public_path__ + "static/media/venue-map.7ba5e5e7.png";